import UserManager from "./container/index";

export default UserManager;
